import { green } from "@maxmilhas/hangar-components-atomic/public/styles/components/quarks/colors";
import {
	fontSize18,
	gridGutterHalf,
	gridGutter1q4,
	gridGutter1q1dot5
} from "@maxmilhas/hangar-components-atomic/public/styles/components/quarks/layout";

export const defaultStyle = (marginMultiplier = 1) => `
    display: flex;
    align-items: center;
    margin: ${marginMultiplier * gridGutter1q4}px ${gridGutter1q4}px;
`;

export const symbolStyle = `
    color: ${green};
    font-size: ${fontSize18};
    font-weight: 500;
    margin-right: ${gridGutter1q1dot5}px;
`;
